import { useMemo, useState, useCallback } from "react";

import { Container, Row } from "reactstrap";

// RangeSlider
import "nouislider/distribute/nouislider.css";
import DeleteModal from "../../Components/Common/DeleteModal";

import BreadCrumb from "../../Components/Common/BreadCrumb";
import TableContainer from "../../Components/Common/TableContainer";
import Loader from "../../Components/Common/Loader";
import {
  useAppelsOffres,
  useDeleteAppelOffre,
} from "../../hooks/useAppelsOffres";
import { getStoredAuthUser } from "../../utils/backendApi";
//Import data

//Import actions

import { Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";
// import { red } from "@material-ui/core/colors";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import defaultIllustration from "../../assets/images/lcbtp.png";

const AppelOffres = (props) => {
  const appelsQ = useAppelsOffres();
  const deleteMutation = useDeleteAppelOffre();

  const rawAppels = appelsQ.data || [];
  const appeloffres = Array.isArray(rawAppels)
    ? rawAppels
    : rawAppels?.results ?? [];

  const role = (getStoredAuthUser()?.role ?? []).some(
    (role) => role === "assistant"
  );

  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [selectedAppelOffre, setSelectedAppelOffre] = useState(null);

  const errorMessage =
    typeof appelsQ.error === "string"
      ? appelsQ.error
      : appelsQ.error?.message || "Erreur";

  const onClickDelete = useCallback((appelOffre) => {
    setSelectedAppelOffre(appelOffre);
    setDeleteModal(true);
  }, []);

  const handleDeleteAppelOffre = () => {
    if (!selectedAppelOffre?.id) return;
    deleteMutation.mutate(selectedAppelOffre.id, {
      onSettled: () => setDeleteModal(false),
    });
  };

  // Delete Multiple
  const deleteMultiple = async () => {
    const ele = document.querySelectorAll(".entrepriseCheckBox:checked");
    const del = document.getElementById("selection-element");

    const ids = Array.from(ele)
      .map((e) => e?.value)
      .filter(Boolean);

    try {
      await Promise.all(ids.map((id) => deleteMutation.mutateAsync(id)));
    } catch (_) {
      // handled by toast
    } finally {
      if (del) del.style.display = "none";
      const checkall = document.getElementById("checkBoxAll");
      if (checkall) checkall.checked = false;
      const all = document.querySelectorAll(".entrepriseCheckBox");
      all.forEach((e) => {
        e.checked = false;
      });
    }
  };

  const checkedAll = useCallback(() => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".entrepriseCheckBox");

    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
  }, []);

  const columns = useMemo(
    () => [
      {
        Header: (
          <input
            type="checkbox"
            id="checkBoxAll"
            onClick={() => checkedAll()}
          />
        ),
        Cell: (cellProps) => {
          return (
            <input
              type="checkbox"
              className="entrepriseCheckBox"
              value={cellProps.row.original.id}
            />
          );
        },
        id: "#",
      },
      {
        Header: props.t("REF"),
        accessor: "reference",
        Cell: (appels) => (
          <>
            <div className="d-flex align-items-center ">
              <div className="flex-grow-1">
                <h5 className="fs-14 mb-1 italic">
                  <Link
                    to={`/appels-offres-details/${appels.row.original.id}`}
                    className="text-dark"
                  >
                    {" "}
                    {appels.row.original.reference}
                  </Link>
                </h5>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: props.t("ILLUSTRATION"),
        Cell: (appels) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <img
                  src={appels.row.original.offer_pic || defaultIllustration}
                  alt={props.t("Illustration")}
                  className="avatar-sm rounded"
                  onError={(e) => {
                    e.currentTarget.onerror = null;
                    e.currentTarget.src = defaultIllustration;
                  }}
                />
              </div>
            </div>
          </>
        ),
      },
      {
        Header: props.t("TITRE"),
        accessor: "title",
        Cell: (appels) => (
          <>
            <div className="d-flex align-items-center ">
              <div className="flex-grow-1">
                <h5
                  className="fs-14 mb-1 uppercase"
                  style={{ textTransform: "uppercase", fontWeight: "bold" }}
                >
                  {appels.row.original.title}
                </h5>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: props.t("DESCRIPTIF"),
        Cell: (appels) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <h5
                  className="fs-14 mb-1 "
                  style={{
                    width: 200,
                    height: 50,
                    overflow: "clip",
                    verticalAlign: "middle",
                  }}
                >
                  <Link
                    to={`/#/${appels.row.original.id}/`}
                    className="text-dark"
                  ></Link>
                  {appels.row.original.description}
                </h5>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: props.t("PUBLIE"),
        accessor: "publication_date",
        Cell: (appels) => (
          <>
            <div className="d-flex align-items-center">
              <div className="">
                <h5
                  className=" mb-1 badge badge-soft-primary"
                  style={{ textAlign: "center" }}
                >
                  <Link
                    to={`/#/${appels.row.original.id}/`}
                    className="text-dark "
                  ></Link>
                  {appels.row.original.publication_date}
                </h5>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: props.t("CLOTURE"),
        accessor: "closure_date",
        Cell: (appels) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                {new Date() > new Date(appels.row.original.closure_date) ? (
                  <h5
                    className="mb-1 badge badge-soft-danger "
                    style={{ textAlign: "center" }}
                  >
                    <Link
                      to={`/#/${appels.row.original.id}/`}
                      className="text-dark "
                    ></Link>
                    {appels.row.original.closure_date}
                  </h5>
                ) : (
                  <h5
                    className="mb-1 badge badge-soft-warning "
                    style={{ textAlign: "center" }}
                  >
                    <Link
                      to={`/#/${appels.row.original.id}/`}
                      className="text-dark "
                    ></Link>
                    {appels.row.original.closure_date}
                  </h5>
                )}
              </div>
            </div>
          </>
        ),
      },
      {
        Header: props.t("STATUT"),
        accessor: "closed",
        Cell: (appels) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                {new Date() > new Date(appels.row.original.closure_date) ||
                new Date(appels.row.original.closure_date) === new Date() ? (
                  <h5
                    className=" mb-1 badge badge-soft-danger "
                    style={{ textAlign: "center" }}
                  >
                    <Link
                      to={`/#/${appels.row.original.id}/`}
                      className="text-dark "
                    ></Link>
                    {"Cloturé"}
                  </h5>
                ) : (
                  <h5
                    className="mb-1 badge badge-soft-success me-1 "
                    style={{ textAlign: "center" }}
                  >
                    <Link
                      to={`/#/${appels.row.original.id}/`}
                      className="text-dark "
                    ></Link>
                    {"En cours"}
                  </h5>
                )}
              </div>
            </div>
          </>
        ),
      },
      {
        Header: props.t("FICHIER"),
        Cell: (appels) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                {appels.row.original.offer_file ? (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <a
                      className="text-xs rounded"
                      href={appels.row.original.offer_file}
                      title="Télécharger"
                    >
                      <i
                        style={{
                          fontSize: "30px",
                          width: "50%",
                          height: "50%",
                          color: "red",
                        }}
                        className="ri-file-download-fill align-bottom"
                      ></i>
                    </a>
                  </div>
                ) : (
                  "-"
                )}
              </div>
            </div>
          </>
        ),
      },
      {
        Header: props.t("STATUT"),
        Cell: (recruitments) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <h5 className="fs-14  p-2">
                  <span className="mt-4">
                    {recruitments.row.original.published === false && !role ? (
                      <div>
                        <div className="btn btn-soft-success">
                          <Link
                            to={`/appels-offres-details/${recruitments.row.original.id}`}
                          >
                            Publier
                          </Link>
                        </div>
                      </div>
                    ) : (
                      <h5
                        className="mb-1 badge badge-soft-success "
                        style={{ fontSize: "10px" }}
                      >
                        Publiée
                      </h5>
                    )}
                  </span>
                </h5>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: "ACTIONS",
        Cell: (cellProps) => {
          const appelsData = cellProps.row.original;
          return (
            <div className="d-flex gap-2">
              <li className="list-inline-item" title={props.t("Modifier")}>
                <Link
                  to={`/appels-offres-update/${appelsData.id}`}
                  className="text-warning d-inline-block"
                >
                  <i className="ri-pencil-fill align-bottom"></i>
                </Link>
              </li>

              <li className="list-inline-item" title={props.t("Voir")}>
                <Link
                  to={`/appels-offres-details/${appelsData.id}`}
                  className="text-warning d-inline-block"
                >
                  <i className="ri-eye-fill"></i>
                </Link>
              </li>

              <li className="list-inline-item" title={props.t("Supprimer")}>
                <Link
                  to="#"
                  className="text-danger d-inline-block"
                  onClick={() => onClickDelete(appelsData)}
                >
                  <i className="ri-delete-bin-5-line align-middle"></i>
                </Link>
              </li>
            </div>
          );
        },
      },
    ],
    [props, role, checkedAll, onClickDelete]
  );

  document.title = props.t("Liste des appels d'offres");

  if (appelsQ.isLoading) return <Loader />;
  if (appelsQ.isError) return <Loader error={errorMessage} />;

  return (
    <div className="page-content">
      <ToastContainer closeButton={false} />

      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteAppelOffre}
        onCloseClick={() => setDeleteModal(false)}
        isPending={deleteMutation.isPending}
      />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb
          title={props.t("Liste des appels d'offres")}
          pageTitle={props.t("Appels d'Offres")}
        />
        <Row>
          <div className="col-xl-12 col-lg-12">
            <div>
              <div className="card">
                <div className="card-body pt-0">
                  {appeloffres && appeloffres.length > 0 ? (
                    <TableContainer
                      columns={columns}
                      data={appeloffres || []}
                      isGlobalFilter={true}
                      isAddUserList={false}
                      customPageSize={10}
                      divClass="table-responsive mb-1"
                      tableClass="mb-0 align-middle "
                      theadClass="table-light text-muted"
                      isAppelsOffresFilter={true}
                    />
                  ) : (
                    <div className="py-4 text-center">
                      <div className="mt-4">
                        <h5>{props.t("Désolé, pas de resultats trouvés")}</h5>
                      </div>
                      <div className="mt-4">
                        <Link
                          to="/appels-offres-add"
                          className="btn btn-warning"
                        >
                          <i className="ri-add-line align-bottom me-1"></i>{" "}
                          {props.t("Ajouter un appel d'offre")}
                        </Link>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Row>
      </Container>
    </div>
  );
};
AppelOffres.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter(withTranslation()(AppelOffres));
